// 智慧招商
import agentNav from '../view/Agent/agentNav'
import investmentManage from '../view/Agent/investmentManage/investmentManage'
import investmentAdd from '../view/Agent/investmentManage/investmentAdd'
import agentManage from '../view/Agent/agentManage/agentManage'
import agentHouse from '../view/Agent/agentHouse/agentHouse'
import agentHouseAdd from '../view/Agent/agentHouse/agentHouseAdd'
import agentApply from '../view/Agent/agentApply/agentApply'
import orderRecord from '../view/Agent/orderRecord/orderRecord'
import agentShowing from '../view/Agent/agentShowing/agentShowing'
import agentShowingAdd from '../view/Agent/agentShowing/agentShowingAdd'
import agentShowingModify from '../view/Agent/agentShowing/agentShowingModify'
import agentConfig from '../view/Agent/agentConfig/agentConfig'
import CustomManagement from '../view/Agent/CustomManagement/CustomManagement'
import CustomAdd from '../view/Agent/CustomManagement/CustomAdd'
import CustomCurrent from '../view/Agent/CustomManagement/CustomCurrent'
import CustomModify from '../view/Agent/CustomManagement/CustomModify'
import Log from '../view/log'

export default [
  /* 经纪人 */
  {
    path: '/investment_manage',
    name: 'investment-manage',
    components: {
      default: agentNav,
      a: investmentManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/investment_add',
    name: 'investment-add',
    components: {
      default: agentNav,
      a: investmentAdd
    }
  },
  {
    path: '/agent_manage',
    name: 'agent-manage',
    components: {
      default: agentNav,
      a: agentManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/agent_house',
    name: 'agent-house',
    components: {
      default: agentNav,
      a: agentHouse
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/agent_house_add',
    name: 'agent-house-add',
    components: {
      default: agentNav,
      a: agentHouseAdd
    }
  },
  {
    path: '/agent_apply',
    name: 'agent-apply',
    components: {
      default: agentNav,
      a: agentApply
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/order_record',
    name: 'order-record',
    components: {
      default: agentNav,
      a: orderRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/agent_showing',
    name: 'agent-showing',
    components: {
      default: agentNav,
      a: agentShowing
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/agent_showing_add',
    name: 'agent-showing-add',
    components: {
      default: agentNav,
      a: agentShowingAdd
    }
  },
  {
    path: '/agent_showing_modify',
    name: 'agent-showing-modify',
    components: {
      default: agentNav,
      a: agentShowingModify
    }
  },
  {
    path: '/agent_config',
    name: 'agent-config',
    components: {
      default: agentNav,
      a: agentConfig
    }
  },
  /* 经纪人 */
  {
    path: '/custom_management',
    name: 'custom-management',
    components: {
      default: agentNav,
      a: CustomManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/custom_add',
    name: 'custom-add',
    components: {
      default: agentNav,
      a: CustomAdd
    }
  },
  {
    path: '/custom_current/:id',
    name: 'custom-current',
    components: {
      default: agentNav,
      a: CustomCurrent
    }
  },
  {
    path: '/custom_modify/:id',
    name: 'custom-modify',
    components: {
      default: agentNav,
      a: CustomModify
    }
  },
  {
    path: '/agent_log',
    name: 'agent-log',
    components: {
      default: agentNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/Agent.js